import './AppLoadingOverlay.scss';

export const AppLoadingOverlay = () => (
  <div className="app-loading-overlay">
    <div className="app-loading-overlay__spinner" />
  </div>
);
